<template>
  <SectionWrapper
    :title="title"
    :to="{ name: 'woori-crowd' }"
    :subtitle="subtitle"
    :no-content="isExecuting"
  >
    <InvestingSection v-if="investingWooriCrowd && !isExecuting" :loan="investingWooriCrowd" />
    <RepaymentSection v-else-if="executedWooriCrowd" :loan="executedWooriCrowd" />
  </SectionWrapper>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    SectionWrapper: () => import('@/components/main/SectionWrapper.vue'),
    InvestingSection: () => import('@/components/main/cards/InvestingSection.vue'),
    RepaymentSection: () => import('@/components/main/cards/RepaymentSection.vue'),
  },

  computed: {
    ...mapGetters('loan', [
      'isWooricrowdsOfferRequest',
      'investingWooriCrowd',
      'executedWooriCrowd',
    ]),

    subtitle() {
      if (this.isExecuting) {
        return '계약서 작성이 완료되어 송금 준비중 입니다.'
      }

      if (this.executedWooriCrowd) {
        const {
          executedAt,
          offer: { periodInDays },
        } = this.executedWooriCrowd
        const excStr = this.$moment(executedAt).format('YYYY-MM-DD')
        const expStr = this.$moment(executedAt).add(periodInDays, 'days').format('YYYY-MM-DD')

        return `${excStr} 실행 ~ ${expStr} 만기`
      }

      return null
    },

    isExecuting() {
      return this.investingWooriCrowd?.status === 'executing'
    },
    currentWooriCrowd() {
      return this.investingWooriCrowd || this.executedWooriCrowd
    },
    wooriCrowdYear() {
      const executedAt = this.$moment(this.currentWooriCrowd.executedAt)
      const yearMonth = executedAt.format('YYYY-MM')
      let year = parseInt(executedAt.format('YYYY'))
      if (yearMonth >= '2023-01' && yearMonth <= '2024-03') {
        year = 2023
      }
      return year
    },
    title() {
      return `${this.wooriCrowdYear} 우리동네 크라우드펀딩`
    },
  },
}
</script>

<style lang="scss" scoped></style>
